import axiosInstance from 'helpers/axiosInstance';

interface AgreementResponse {
  agreement: string;
}

export const signFamilyAgreements = async (refAgreementCode: string) => {
  const url = '/patients/agreements/create_family_agreements';
  const params = {
    agreement: {
      ref_agreement_code: refAgreementCode,
    },
  };

  return axiosInstance.post<AgreementResponse>(url, params).then(r => r.data);
};
